module.exports = __webpack_public_path__ + "static/media/sponsors_bg_new.50e7490b.png";